import front from './view';

export default [
  {
    path: 'complaint/step',
    component: front('/complaint/step'),
  },
  {
    path: 'complaint/poor',
    component: front('/complaint/poor'),
  },
  {
    path: 'complaint/weak',
    component: front('/complaint/weak'),
  },
  {
    path: 'complaint/dissatisfaction',
    component: front('/complaint/dissatisfaction'),
  },
  {
    path: 'complaint/:category/apply',
    component: front('/complaint/apply'),
  },
  {
    path: 'complaint/:category/complete',
    component: front('/complaint/complete'),
  },
  {
    path: 'complaint/my',
    component: front('/complaint/my'),
  },
  {
    path: 'complaint/myList',
    component: front('/complaint/myList'),
  },
  {
    path: 'complaint/my/:sq',
    component: front('/complaint/myView'),
  },
];




// WEBPACK FOOTER //
// ./src/router/front/complaint.js